export default __webpack_public_path__ + "static/media/location1.83ee0575.svg";